<template>
  <v-container fluid>
    <v-progress-linear v-if="loading" indeterminate color="deep-purple" />
    <h5 class="grey--text">Vista general</h5>
    <v-row>
        <v-col md="6">
            <h2 class="deep-purple--text lighten-3">
              {{$t('directive_admins.all_directive_admins')}}
            </h2>
        </v-col>
        <v-col md="6">
            <v-row justify="end" class="my-0 mr-4">
                <v-btn
                  text
                  small
                  color="deep-purple lighten-1"
                  @click.prevent="toggleCreateDirectiveAdminModal()"
                >
                    <v-icon size="21" class="mr-1">
                    mdi-plus
                    </v-icon>
                    {{ $t('directive_admins.create') }}
                </v-btn>
            </v-row>
        </v-col>
    </v-row>
    <directive-admins-filter
      v-model="params"
      @search="search(true)"
    ></directive-admins-filter>
    <directive-admins-data-table
      :table-loading="loading"
      v-model="page"
      :items="directiveAdmins"
      :length="totalPages"
      @edit="editDirectiveAdmin"
      @refresh="handleRefresh"
    ></directive-admins-data-table>
    <create-directive-admin-modal
      v-model="isCreateDirectiveAdminModalOpen"
      @onCancel="toggleCreateDirectiveAdminModal"
      @onSave="handleDirectiveAdminCreated"
    />
  </v-container>
</template>

<script>
import CreateDirectiveAdminModal from '@/components/directiveAdmins/modals/CreateDirectiveAdminModal.vue';
import DirectiveAdminsFilter from '../../components/core/filters/DirectiveAdminsFilter.vue';
import DirectiveAdminsDataTable from '../../components/directiveAdmins/DirectiveAdminsDataTable.vue';
import LoadingMixin from '../../mixins/loading';
import snackbarMixin from '../../mixins/snackbar';

import directiveAdminService from '../../services/directiveAdmin.service';
import { defaultDirectiveAdminFilter } from '../../constants/filters';

export default {
  name: 'DirectiveAdmins',
  components: {
    DirectiveAdminsFilter,
    DirectiveAdminsDataTable,
    CreateDirectiveAdminModal,
  },
  data: () => ({
    page: 1,
    params: { ...defaultDirectiveAdminFilter },
    isCreateDirectiveAdminModalOpen: false,
    isSearching: false,
  }),
  mixins: [LoadingMixin, snackbarMixin],
  computed: {
    directiveAdmins() {
      return this.$store.state.directiveAdmins;
    },
    totalPages() {
      return this.$store.state.directiveAdminsTotalPages;
    },
  },
  mounted() {
    this.search(true);
  },
  methods: {
    toggleCreateDirectiveAdminModal() {
      this.isCreateDirectiveAdminModalOpen = !this.isCreateDirectiveAdminModalOpen;
    },
    editDirectiveAdmin(directiveAdmin) {
      this.$router.push(`/edit/directive-admins/${directiveAdmin.id}`);
    },
    handleRefresh() {
      this.search(true);
    },
    handleDirectiveAdminCreated() {
      this.toggleCreateDirectiveAdminModal();
      this.search(true);
      this.snackbarSuccess('Directivo creado exitosamente');
    },
    async search(showLoading = false) {
      this.isSearching = true;

      if (showLoading) {
        this.page = 1;
        this.loader();
      }

      const queryParams = {
        page: this.page,
        ...this.params,
      };

      try {
        const response = await directiveAdminService.getDirectiveAdmins(queryParams);
        this.$store.commit('SET_DIRECTIVE_ADMINS', response.data.data);
        this.$store.commit('SET_DIRECTIVE_ADMINS_TOTAL_PAGES', response.data.total_page);
      } catch (error) {
        this.snackbarError('Error al cargar directivos');
      } finally {
        if (showLoading) {
          this.loader();
        }
        this.isSearching = false;
      }
    },
  },
  watch: {
    page() {
      if (!this.isSearching) {
        this.search();
      }
    },
  },
};
</script>
